import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { orderApi } from '../services/api'
import ErrorMessage from '../components/ErrorMessage'
import Loading from '../components/Loading'

export default function Query() {
  const navigate = useNavigate()
  const [orderNo, setOrderNo] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleQuery = async () => {
    if (!orderNo.trim()) {
      setError('请输入订单号或交易流水号')
      return
    }
    setError('')
    setLoading(true)
    try {
      await orderApi.getPublic(orderNo.trim())
      navigate(`/detail/${orderNo.trim()}`)
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : '查询失败'
      setError(message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen page-enter" style={{ backgroundColor: '#eeeeee' }}>
      {/* Nav */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px 24px',
        borderBottom: '1px solid #dddddd',
        backgroundColor: '#ffffff',
      }}>
        <button
          onClick={() => navigate('/')}
          style={{ color: '#9a9a9a', background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <path d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <h1 style={{
          fontFamily: '"Noto Sans SC", sans-serif',
          fontSize: 16,
          fontWeight: 500,
          color: '#313131',
          letterSpacing: '0.15em',
        }}>
          查询订单
        </h1>
        <div style={{ width: 20 }} />
      </div>

      <div style={{ padding: '32px 24px' }}>
        {/* Brand */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h2 style={{
            fontFamily: '"Noto Sans SC", sans-serif',
            fontSize: 28,
            fontWeight: 700,
            color: '#313131',
            letterSpacing: '0.15em',
          }}>
            浅形
          </h2>
          <p style={{
            fontSize: 13,
            color: '#9a9a9a',
            marginTop: 8,
            letterSpacing: '0.15em',
          }}>
            输入订单号查询定制进度
          </p>
        </div>

        {/* Search */}
        <div style={{
          backgroundColor: '#ffffff',
          border: '1px solid #dddddd',
          padding: '20px',
          marginBottom: 16,
        }}>
          <label style={{
            display: 'block',
            fontSize: 13,
            color: '#9a9a9a',
            marginBottom: 12,
            letterSpacing: '0.15em',
          }}>
            订单号 / 交易流水号
          </label>
          <input
            type="text"
            value={orderNo}
            onChange={(e) => setOrderNo(e.target.value)}
            placeholder="如：20241201001"
            style={{
              width: '100%',
              padding: '12px 0',
              fontSize: 16,
              color: '#313131',
              border: 'none',
              borderBottom: '1px solid #dddddd',
              background: 'none',
              outline: 'none',
              fontFamily: '"Inter", "Noto Sans SC", sans-serif',
              letterSpacing: '0.15em',
            }}
            onKeyDown={(e) => e.key === 'Enter' && handleQuery()}
          />
          <p style={{
            fontSize: 12,
            color: '#9a9a9a',
            marginTop: 8,
            letterSpacing: '0.15em',
          }}>
            输入淘宝订单号、微信转账单号或银行流水号
          </p>
        </div>

        {error && <ErrorMessage message={error} onRetry={() => setError('')} />}
        {loading && <Loading />}

        <button
          onClick={handleQuery}
          disabled={loading}
          style={{
            width: '100%',
            padding: '14px',
            fontSize: 15,
            fontWeight: 500,
            color: '#ffffff',
            backgroundColor: loading ? '#dddddd' : '#313131',
            border: 'none',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontFamily: '"Noto Sans SC", sans-serif',
            letterSpacing: '0.15em',
            lineHeight: 1.8,
          }}
        >
          {loading ? '查询中' : '查询订单'}
        </button>

        {/* My Orders Link (if logged in) */}
        {localStorage.getItem('token') && (
          <button
            onClick={() => navigate('/customer/orders')}
            style={{
              width: '100%',
              marginTop: 12,
              padding: '14px',
              fontSize: 15,
              fontWeight: 500,
              color: '#313131',
              backgroundColor: '#ffffff',
              border: '1px solid #dddddd',
              cursor: 'pointer',
              fontFamily: '"Noto Sans SC", sans-serif',
              letterSpacing: '0.15em',
              lineHeight: 1.8,
            }}
          >
            查看我的所有订单
          </button>
        )}
      </div>
    </div>
  )
}
